import { useEffect, useState } from 'react'
import Axios from 'axios';
import { keys, get as getLocalStorage, set as setLocalStorage } from '../../localStorage';

function useHome() {
  async function getPlace() {
    try {
      Axios.get('http://ip-api.com/json')
        .then(response => {
          const country = response.data;
          getInfoPlace(country);
        })
        .catch(error => {
          console.error(error);
        });
    } catch (error) {
      console.log("Error in getPlace()", error)
    }
  }


  async function getInfoPlace(value) {
    try {
      const countryName = value?.country;
      const API_URL = `https://restcountries.com/v3.1/name/${encodeURIComponent(countryName)}?fullText=true`;
      const response = await Axios.get(API_URL);
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        const _country = data[0];
        const country = {
          language: _country.languages,
          name: _country.name.common,
          nameOfficial:_country.name.official,
          currencies: [_country.currencies],
          city: value?.city,
        }
        await setLocalStorage(keys.location, country);
      }

    } catch (error) {
      console.log("Error in getInfoPlace()", error)
    }
  }

  // async function auth() {
  //   try {
  //     const authUser = await getLocalStorage(keys.authUserSession);
  //     console.log("authUser: in home", authUser)
  //   } catch (error) {
  //     console.error('Error in auth home:', error);
  //   }
  // }

  useEffect(() => {
    getPlace();
    // auth();
  }, []);
}

export default useHome;
